// Display metadata for custom_field_responses.source.
// Keep in sync with the ENUM in the `custom_field_responses` table.
//
// Use `sourceLabel()` for the pill text and `sourceVariant()` for styling.
// `INTERNAL_SOURCE` is used by frontend filters (e.g., invoice preview) to
// exclude staff-entered responses from customer-facing views.

export const INTERNAL_SOURCE = 'internal_booking'

// Single icon across all sources — indicates "this badge is a source indicator".
// Per-source icons were tried but overloaded the meaning; the color variant already
// distinguishes the source type visually.
const SOURCE_ICON = 'tim-icons icon-tag-simple'

const META = {
  booking_site:     { label: 'Booking site',  variant: 'primary' },
  internal_booking: { label: 'Internal',      variant: 'neutral' },
  payment_request:  { label: 'Payment link',  variant: 'info' },
  waiver:           { label: 'Waiver',        variant: 'info' },
  api:              { label: 'API',           variant: 'neutral' },
  survey:           { label: 'Survey',        variant: 'info' },
}

export function sourceLabel(source) {
  return (META[source] && META[source].label) || source || ''
}

export function sourceVariant(source) {
  return (META[source] && META[source].variant) || 'neutral'
}

export function sourceIcon(source) {
  return source ? SOURCE_ICON : ''
}

export function isInternalSource(source) {
  return source === INTERNAL_SOURCE
}
